import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { FaqPayload } from "./validation";

export const useGetFaq = (params?: string) =>
  useQuery<ApiResponse<DataPaginate<FaqResponse>>>({
    queryKey: ["useGetFaq", params],
    queryFn: () => fetcher(`website-config/faqs?${params}`),
  });

export const useGetFaqById = (id?: number) =>
  useQuery<ApiResponse<DataObject<FaqResponse>>>({
    queryKey: ["useGetFaqById", id],
    queryFn: () => fetcher(`website-config/faqs/${id}`),
    enabled: !!id,
  });

export const useFaqMutation = (id: number) => {
  return useFormMutation<ApiResponse<DataObject<any>>, Error, FaqPayload>({
    mutationFn: async (payload) => {
      return await sendData(
        id ? `website-config/faqs/${id}` : `website-config/faqs`,
        payload,
        id ? "PUT" : "POST"
      );
    },
    successMessage: `Berhasil ${id ? "Mengupdate" : "Menambah"} Data`,
  });
};
